import mediaCheck from 'mediacheck';
import { setAriaValue } from '../../utilities/accordion';
import {
  getBodyContent,
  getContent,
  handleFocusOutsideMenu,
  handleClickOutsideMenu,
} from '../../utilities/toggleMenuHelpers';

function applyMobileEvents() {
  document.addEventListener('click', handleClickOutsideMenu);
  document.addEventListener('focusin', handleFocusOutsideMenu);
}
function removeMobileEvents() {
  document.removeEventListener('click', handleClickOutsideMenu);
  document.removeEventListener('focusin', handleFocusOutsideMenu);
}

// Secondary Navigation Configuration
function displayContentForDesktop(buttons) {
  const contentSections = [...buttons].map((button) => getContent(button));
  const bodyContent = getBodyContent();

  mediaCheck({
    media: '(min-width: 74.626rem)',
    entry() {
      setAriaValue(contentSections, 'aria-hidden', 'false');
      // if menu is open while moving to larger screen, remove fixed class from body content
      bodyContent.classList.remove('menu--isOpen');
      removeMobileEvents();
    },
    exit() {
      applyMobileEvents();
      setAriaValue(buttons, 'aria-expanded', 'false');
      setAriaValue(contentSections, 'aria-hidden', 'true');
    },
  });
}

function jsFixMenu() {
  const navList = document.querySelector('.cmp-secondary-nav__list');
  navList?.classList?.add('js-enabled-menu');
}

export function configureSecondaryMenu() {
  const secondaryMenuBtn = document.querySelectorAll('.cmp-secondary-nav__button');
  displayContentForDesktop(secondaryMenuBtn);
  jsFixMenu();

  // Prevents menu from flashing when there is JS
  document.querySelector('.closed-by-default')?.classList.remove('closed-by-default');
}
